// extracted by mini-css-extract-plugin
export default {"button":"DateRangePicker_button__u5Rh9","placeholder":"DateRangePicker_placeholder__GLMqK"};